// Copyright (c) 2017 Deere & Company

import AuditDealerHierarchy from '@deere/cps-it.warranty-model-factory/lib/dealer-location-hierarchy';
import actions from '../../actions-list';
import {getDefaultState} from '../state';

const updateAuditLeadAccount = (state, action) =>
AuditDealerHierarchy.update(state, {
    $set: action.leadAccount
});

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.UPDATE_TCSM_AUDIT_LEAD_ACCOUNT]: updateAuditLeadAccount
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/tcsm/audits/reducers/lead-accounts.js